var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.offerta
    ? _c("div", [
        _vm.nomeSquadra
          ? _c("div", [
              _c(
                "div",
                { class: ["squadra-offerta", { small: _vm.small }] },
                [
                  _c(
                    "div",
                    { staticClass: "squadra-wrapper" },
                    [
                      _c("img", {
                        staticClass: "picture",
                        attrs: { src: _vm.picSquadra },
                      }),
                      _vm._v(" "),
                      _vm.showBadgeOfferta
                        ? _c("crediti", {
                            staticClass: "crediti-badge",
                            attrs: {
                              crediti: _vm.offerta,
                              variant: _vm.creditiStyle,
                              glow: _vm.creditiGlow,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.label != ""
                    ? _c("div", { staticClass: "text-left ml-2" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "label font-hemi-head text--text text--lighten-2",
                          },
                          [_vm._v(_vm._s(_vm.label))]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "nome" }, [
                          _vm._v(_vm._s(_vm.nomeSquadra)),
                        ]),
                        _vm._v(" "),
                        _vm.time
                          ? _c(
                              "div",
                              { staticClass: "offerta_time" },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", left: "" } },
                                  [_vm._v("access_time")]
                                ),
                                _c("small", [
                                  _c("span", {
                                    domProps: { innerHTML: _vm._s(_vm.time) },
                                  }),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showHorizontalOfferta
                    ? _c("crediti", {
                        staticClass: "crediti-horizontal",
                        attrs: {
                          crediti: _vm.offerta,
                          "use-icon": "",
                          variant: _vm.creditiStyle,
                          glow: _vm.creditiGlow,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ])
    : _c("div", [
        _vm.ifNoOfferta != ""
          ? _c("div", [_c("div", [_vm._v(_vm._s(_vm.ifNoOfferta))])])
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }